import { KycVerificationStatusEnumType } from "@oysterhr/schema"
import { Duration } from "luxon"

export const KYC_REFETCH_INTERVAL = Duration.fromObject({ minutes: 1 }).toMillis()

export const KYC_STATUS_THAT_SHOULD_REFETCH = [KycVerificationStatusEnumType.Submitted]
